/**
 * Continuous Scan Bridge - Web Stub (Native Only)
 * This module provides mock implementations for web
 */

export function initializeContinuousScanBridge() {
    console.warn('ContinuousScanBridge: Not available on web');
}

export function startContinuousScan() {
    return Promise.reject(new Error('ContinuousScanBridge not available on web'));
}

export function finishContinuousScan() {
    return Promise.reject(new Error('ContinuousScanBridge not available on web'));
}

export function cancelContinuousScan() {
    return Promise.reject(new Error('ContinuousScanBridge not available on web'));
}

export function pauseContinuousScan() {
    return Promise.reject(new Error('ContinuousScanBridge not available on web'));
}

export function resumeContinuousScan() {
    return Promise.reject(new Error('ContinuousScanBridge not available on web'));
}

export function setNetworkStatus() {
    return Promise.reject(new Error('ContinuousScanBridge not available on web'));
}

export function cleanupContinuousScanBridge() {
    // No native event listeners are registered on web, so there is nothing to clean up.
}

export default {
    initializeContinuousScanBridge,
    startContinuousScan,
    finishContinuousScan,
    cancelContinuousScan,
    pauseContinuousScan,
    resumeContinuousScan,
    setNetworkStatus,
    cleanupContinuousScanBridge
};
